// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Zicgk","form":"classes_form__iAAKS","user-created":"classes_user-created__RN1MF"};